import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserPlus, Trash2 } from "lucide-react";
import { adminApi, fmtDate } from "./adminApi";

export const StaffTab = ({ user }) => {
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  const isOwner = user.role === "owner";
  const load = () => adminApi.get("/admin/staff").then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await adminApi.post("/admin/staff", { email });
      toast.success("Aggiunto allo staff. Ora può entrare con il suo account Google.");
      setEmail(""); load();
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Email non valida.");
    }
  };
  const remove = async (m) => {
    await adminApi.delete(`/admin/staff/${encodeURIComponent(m)}`);
    toast.success("Rimosso dallo staff."); load();
  };

  return (
    <div className="grid lg:grid-cols-12 gap-8" data-testid="staff-tab">
      <div className="lg:col-span-7 space-y-2" data-testid="staff-list">
        {list.map((s) => (
          <div key={s.email} className="flex items-center justify-between gap-3 rounded-2xl bg-[#FCFBF7] border border-[#1B3B28]/8 px-5 py-4" data-testid={`staff-row-${s.email}`}>
            <div>
              <p className="text-[#1B3B28] break-all">{s.email}</p>
              <p className="text-xs text-[#526356] mt-0.5">{s.role === "owner" ? "Titolare" : "Staff"} · dal {fmtDate(s.added_at, { day: "numeric", month: "long", year: "numeric" })}</p>
            </div>
            {isOwner && s.role !== "owner" && (
              <button onClick={() => remove(s.email)} aria-label="Rimuovi" data-testid={`staff-remove-${s.email}`} className="w-9 h-9 grid place-items-center rounded-full text-[#9A4B3C] hover:bg-[#F4DCD6]"><Trash2 size={16} /></button>
            )}
          </div>
        ))}
      </div>
      <div className="lg:col-span-5">
        {isOwner ? (
          <form onSubmit={add} className="rounded-[1.75rem] bg-[#FCFBF7] border border-[#1B3B28]/10 p-6" data-testid="staff-add-form">
            <p className="f-serif text-3xl text-[#1B3B28]">Aggiungi un membro</p>
            <p className="text-sm text-[#526356] mt-2">Inserisci l'indirizzo Gmail con cui accederà. Potrà vedere prenotazioni, calendario e storico email.</p>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@gmail.com" data-testid="staff-email-input"
              className="mt-5 w-full rounded-2xl border border-[#1B3B28]/15 bg-[#F4F3EC] px-4 py-3.5 text-[#1B3B28] focus:outline-none focus:ring-2 focus:ring-[#86C89B]" />
            <button type="submit" data-testid="staff-add-btn" className="mt-4 w-full flex items-center justify-center gap-2 rounded-full bg-[#1B3B28] text-[#FCFBF7] py-3.5 text-sm hover:bg-[#3E6B48] transition-colors"><UserPlus size={16} /> Aggiungi allo staff</button>
          </form>
        ) : <p className="text-sm text-[#526356]" data-testid="staff-readonly-note">Solo il titolare può aggiungere o rimuovere membri dello staff.</p>}
      </div>
    </div>
  );
};
